<template>
	<el-tiptap :extensions="extensions" :content="content" placeholder="Write something ..." @onUpdate="onUpdateEvent" :readonly="readonly" style="height: 900px;" :showMenubar="!readonly" :tooltip="!readonly" />
</template>

<script>
import {
	Blockquote,
	Bold,
	BulletList,
	Doc,
	Fullscreen,
	HardBreak,
	Heading,
	History,
	HorizontalRule,
	Image,
	Indent,
	Italic,
	Link,
	ListItem,
	Paragraph,
	Strike,
	Text,
	TextAlign,
	TodoItem,
	TodoList,
	Underline,
	CodeView,
	Table,
	TableHeader,
	TableRow,
	TableCell,
} from 'element-tiptap';
import codemirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/addon/selection/active-line.js';
import 'codemirror/addon/edit/closetag.js';
export default {
	name: 'Editor',
	props: ['content', 'readonly'],
	data: () => ({
		extensions: [
			new Doc(),
			new Text(),
			new Paragraph(),
			new Heading({ level: 5 }),
			new Bold({ bubble: true }),
			new Underline({ bubble: true }),
			new Italic({ bubble: true }),
			new Strike({ bubble: true }),
			new Link({ bubble: true }),
			new Image(),
			new Blockquote(),
			new TextAlign(),
			new ListItem(),
			new BulletList({ bubble: true }),
			new TodoItem(),
			new TodoList(),
			new Indent(),
			new HardBreak(),
			new HorizontalRule({ bubble: true }),
			new Table({ resizable: true }),
			new TableHeader(),
			new TableCell(),
			new TableRow(),
			new Fullscreen(),
			new CodeView({
				codemirror,
				codemirrorOptions: {
					styleActiveLine: true,
					autoCloseTags: true,
				},
			}),
			new History(),
		],
	}),
	methods: {
		onUpdateEvent(e) {
			this.$emit('input', e);
		},
	},
};
</script>
